export const normalizeTalentLmsSyncEmailKey = (email) => (email || '').trim();

export const shouldSkipTalentLmsSyncFetch = (entry, { force = false } = {}) => {
	if (force) return false;
	if (!entry) return false;
	return entry.loading || (!entry.error && entry.syncStatus);
};

export const clearTalentLmsSyncEntry = (state, email) => {
	const emailKey = normalizeTalentLmsSyncEmailKey(email);
	if (!emailKey || !state[emailKey]) return state;
	const next = { ...state };
	delete next[emailKey];
	return next;
};

export const getTalentLmsSyncRtkCacheKey = (email) =>
	`userTalentLmsSync-${normalizeTalentLmsSyncEmailKey(email)}`;
